<ion-content  class="ion-no-padding">

  <ion-grid class="confirm-wrap">
    <ion-row class="confirm-row ion-align-items-center ion-justify-content-center">

      <ion-col size="12" class="secondary-text ion-text-center">
        <ion-img class="picture" [src]="image"></ion-img>
        <h1 class="title">{{ title }}</h1>
        <h3 class="subtitle">{{ subtitle }}</h3>
        <ion-button *ngFor='let button of buttons' (click)="closeModal(button.path)" color="secondary">{{ button.title }}</ion-button>
      </ion-col>

    </ion-row>
  </ion-grid>  

</ion-content>